export default "data:text/plain;base64,MC4yLDAuMywwLjQsMC40NSwwLjUsMC41NSwwLjYsMC43LDAuOCwwLjksMC45NSYwLjAsMC4xLDAuMiwwLjMsMC40LDAuNSwwLjYsMC43LDAuOCwwLjksMS4w"